import LogoWhite from "../assets/images/Logo_White.png";
import LogoGray from "../assets/images/Logo_Gray.png";
import SideMenu from "../assets/images/side_menu.png";
import BgLogin from "../assets/images/Bg-Login.png";

const Images = {
  LogoWhite,
  LogoGray,
  SideMenu,
  BgLogin,
};

export default Images;
